import axiosInstance from './axiosInstance';
import { PATH_NAME } from '../configs/pathName';
import { handleError } from '../helpers/Fetchers/fetchers';
import { IBadge } from '../models/IBadge';
 
export const getBadgeByID = async (id: string | number) => {
    try {
        const response = await axiosInstance.get(PATH_NAME.API_BADGES_BY_ID(id));
        return response.data.result as IBadge;
    } catch (error) {
        handleError(error, 'fetching badge');
        throw new Error('Failed to fetch badge');
    }
}